/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { VerifyEmail200ResponseDataTokens } from './VerifyEmail200ResponseDataTokens'
import {
  VerifyEmail200ResponseDataTokensFromJSON,
  VerifyEmail200ResponseDataTokensFromJSONTyped,
  VerifyEmail200ResponseDataTokensToJSON,
} from './VerifyEmail200ResponseDataTokens'
import type { User } from './User'
import { UserFromJSON, UserFromJSONTyped, UserToJSON } from './User'

/**
 *
 * @export
 * @interface VerifyEmail200ResponseData
 */
export interface VerifyEmail200ResponseData {
  /**
   *
   * @type {User}
   * @memberof VerifyEmail200ResponseData
   */
  user: User
  /**
   *
   * @type {VerifyEmail200ResponseDataTokens}
   * @memberof VerifyEmail200ResponseData
   */
  tokens: VerifyEmail200ResponseDataTokens
}

/**
 * Check if a given object implements the VerifyEmail200ResponseData interface.
 */
export function instanceOfVerifyEmail200ResponseData(
  value: object
): value is VerifyEmail200ResponseData {
  if (!('user' in value) || value['user'] === undefined) return false
  if (!('tokens' in value) || value['tokens'] === undefined) return false
  return true
}

export function VerifyEmail200ResponseDataFromJSON(
  json: any
): VerifyEmail200ResponseData {
  return VerifyEmail200ResponseDataFromJSONTyped(json, false)
}

export function VerifyEmail200ResponseDataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): VerifyEmail200ResponseData {
  if (json == null) {
    return json
  }
  return {
    user: UserFromJSON(json['user']),
    tokens: VerifyEmail200ResponseDataTokensFromJSON(json['tokens']),
  }
}

export function VerifyEmail200ResponseDataToJSON(
  value?: VerifyEmail200ResponseData | null
): any {
  if (value == null) {
    return value
  }
  return {
    user: UserToJSON(value['user']),
    tokens: VerifyEmail200ResponseDataTokensToJSON(value['tokens']),
  }
}
